<div class="app-shell">
  <router-outlet />
</div>
